import { render, staticRenderFns } from "./TransferIssueVoucherDisplayView.vue?vue&type=template&id=0db72f68"
import script from "./TransferIssueVoucherDisplayView.vue?vue&type=script&lang=js"
export * from "./TransferIssueVoucherDisplayView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports